import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colorsEnum, typeEnum } from "./CovidHerdImmunityConstants";

const Container = styled.section`
  h2 {
    margin-bottom: 10px !important;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    border-bottom: 1px solid #eaeaea;
    padding: 8px;
    white-space: nowrap;
  }

  li:nth-child(1) strong {
    color: ${colorsEnum[typeEnum.SICK]};
  }
  li:nth-child(2) strong {
    color: ${colorsEnum[typeEnum.HEALTHY]};
  }
  li:nth-child(3) strong {
    color: ${colorsEnum[typeEnum.RECOVERED]};
  }
  li:nth-child(4) strong {
    color: ${colorsEnum[typeEnum.DEAD]};
  }

  @media (max-width: 767px) {
    h2 {
      margin-bottom: 5px !important;
    }

    ul {
      border-bottom: 1px solid #eaeaea;
      display: flex;
      justify-content: space-between;
    }

    li {
      border: 0;
      padding: 8px 0;
    }
  }
`;

function CovidHerdImmunityStats({ stats }) {
  return (
    <Container>
      <h2>Décompte</h2>
      <ul>
        <li>
          Contaminé : <strong>{stats[1]}</strong>
        </li>
        <li>
          Sain : <strong>{stats[0]}</strong>
        </li>
        <li>
          Immunisé : <strong>{stats[2]}</strong>
        </li>
        {/* <li>
          Mort : <strong>{stats[3]}</strong>
        </li> */}
      </ul>
    </Container>
  );
}

CovidHerdImmunityStats.propTypes = {
  stats: PropTypes.shape({
    "0": PropTypes.number,
    "1": PropTypes.number,
    "2": PropTypes.number,
    "3": PropTypes.number,
  }).isRequired,
};

export default CovidHerdImmunityStats;
